import { lazy } from "react";
import { getRoute } from "util/react";

export const OrderDetailsRoute = getRoute(
  { fullPath: "/:locale?/order/details/:id" },
  "order/details/:id",
  lazy(() => import("./orderDetails")),
  null,
);

export const CancelOrderRoute = getRoute(
  { fullPath: "/:locale?/order/cancel/:id" },
  "order/cancel/:id",
  lazy(() => import("./cancelOrder")),
  null,
);

export const OrderPaymentResponseRoute = getRoute(
  { fullPath: "/:locale?/order/payment-response" },
  "order/payment-response",
  lazy(() => import("./paymentResponse")),
  null,
);

const OrderRoute = (
  <>
    {CancelOrderRoute}
    {OrderDetailsRoute}
    {OrderPaymentResponseRoute}
  </>
);

export default OrderRoute;
